// extracted by mini-css-extract-plugin
export default {"video":"video_video__w1acr","close":"video_close__0hgEZ","show":"video_show__GttsR"};